import React, { FC, ReactNode } from 'react';
import cn from 'classnames';
import NextImage from '../NextImage/NextImage';

export enum ButtonVariant {
  minimalistic,
  regular
}

export enum ButtonColor {
  gray = 'bg-gallery',
  blue = 'bg-astronautBlue',
  vermilion = 'bg-vermilion'
}

const buttonIconSize = {
  height: 17,
  width: 17
};

export enum ButtonIcon {
  cartIcon = 'shared/new-cart.svg',
  listIcon = 'shared/list-icon-dark.svg',
  bellIcon = 'shared/new-bell.svg',
  checkIcon = 'shared/tick-icon.svg',
  arrowIcon = 'shared/arrow-forward.svg'
}

export enum ButtonSizeList {
  sm = 'h-[32px]',
  base = 'h-[40px]'
}

interface Props extends React.HTMLProps<HTMLButtonElement> {
  onClick?: (event: React.FormEvent<HTMLButtonElement>) => void;
  buttonLabel?: ReactNode;
  className?: string;
  isLoading?: boolean;
  disabled?: boolean;
  variant?: ButtonVariant;
  color: ButtonColor;
  type?: 'submit' | 'reset' | 'button' | undefined;
  icon?: {
    variant: ButtonIcon;
    size?: { width: number; height: number };
    alt: string;
    priority?: boolean;
  };
  buttonSize?: ButtonSizeList;
  iconClass?: string;
}

const Button: FC<Props> = ({
  buttonLabel,
  onClick,
  className = '',
  disabled = false,
  variant = ButtonVariant.regular,
  color,
  icon,
  type = 'button',
  buttonSize = ButtonSizeList.base,
  iconClass = 'justify-between',
  ...otherProps
}) => {
  return (
    <button
      className={cn(
        'flex items-center justify-center rounded-lg ',
        disabled && 'cursor-not-allowed',
        color,
        className,
        buttonSize
      )}
      onClick={onClick}
      disabled={disabled}
      {...otherProps}
    >
      <div className={cn('flex w-full h-full px-[16px] py-[10px]', iconClass)}>
        {icon && (
          <div
            className={cn(
              'flex items-center ',
              variant === ButtonVariant.regular && 'pr-[10px]'
            )}
          >
            <NextImage
              alt={icon.alt}
              src={icon.variant}
              layout="fixed"
              height={icon.size ? icon.size.height : buttonIconSize.height}
              width={icon.size ? icon.size.width : buttonIconSize.width}
              priority={icon?.priority ?? false}
            />
          </div>
        )}
        {variant === ButtonVariant.regular && (
          <div
            className={cn(
              'flex justify-center items-center w-full rounded-r-md fs-body-bold'
            )}
          >
            {buttonLabel}
          </div>
        )}
      </div>
    </button>
  );
};

export default Button;
